import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

const ButtonHireMembership = () => {
  const navigate = useNavigate();
  return (
    <Button
      variant="text"
      sx={{ color: "#e7ef7d" }}
      onClick={() => navigate("/dashboard/list-memberships")}
    >
      Contrata una Mmbresía
    </Button>
  );
};

export default ButtonHireMembership;
